<template>
  <v-container class="px-0 py-1">
      <v-form ref="FeriadosFilterForm">
        <v-row>
          <v-col class="py-0 px-3" cols="12" sm="12" md="10">
            <legend>Prestador</legend>
            <v-select
                v-model="form.prestador_id"
                :items="prestadoresFilter"
                item-value="id"
                item-text="prest_nome"
                :menu-props="{ bottom: true, offsetY: true }"
                placeholder="Selecione"
                flat
                solo
                dense
                outlined
                @change="sendPrestador(form)"
            ></v-select>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="10">
            <label>Data</label>
            <v-menu
              ref="dt"
              v-model="dt"
              :close-on-content-click="true"
              transition="scale-transition"
              offset-y
              max-width="100%"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-model="dateFormatted"
                  dense
                  v-mask="'##/##/####'"
                  format="DD/MM/YYYY"
                  placeholder="DD/MM/YYYY"
                  label
                  outlined
                  v-bind="attrs"
                  v-on="on"
                  append-icon="mdi-calendar-blank"
                  @blur="date = parseDate(dateFormatted)"
                  :rules="[formRules.typeDateFormated]"
                ></v-text-field>
              </template>
              <v-date-picker color="primary"  v-model="date" no-title scrollable></v-date-picker>
            </v-menu>
          </v-col>
          <v-col class="py-0" cols="12" sm="12" md="10">
            <label>Nome do feriado</label>
            <v-text-field
              v-model="formData.descricao"
              dense
              type="text"
              outlined
            ></v-text-field>
          </v-col>
          <v-col class="text-left py-0" cols="12" sm="6" md="5">
            <v-btn
              outlined
              max-width="100%"
              height="30px"
              small
              color="primary"
              depressed
              class="px-2"
              @click="wip()"
              >cancelar</v-btn>
          </v-col>
          <v-col class="text-right py-0" cols="12" sm="6" md="5">
            <v-btn
              :disabled="!showBtn"
              max-width="100%"
              height="30px"
              small
              color="primary"
              depressed
              class="px-2"
              @click="sendFilter()"
              >salvar</v-btn>
          </v-col>
      </v-row>
      </v-form>
  </v-container>
</template>

<script>
import { mapState } from "vuex"
export default {
  data() {
    return {
      formData: {
        dt_feriado: null,
        descricao: null,
        year: null
      },
      form: {
        prestador_id: null,
        year: new Date().getFullYear()
      },
      date:null,
      dateFormatted: null,
      dt: false, 
      prestadoresFilter: [],
    }
  },
  computed: {
    ...mapState({
      formRules: state => state.formRules
    }),
  },  
  watch: {
    prestadores:{
      deep: true,
      handler(val){
        this.prestadoresFilter = Array.from(val)
        if(this.prestadoresFilter.length==1){
         this.form.prestador_id = val[0].id
         this.sendPrestador(this.form)
        } else {
          this.prestadoresFilter.unshift({id: null, prest_nome: "Selecione"})
        }
      }
    },    
    dateFormatted(val) {
      this.formData.dt_feriado = this.parseDate(val);
      this.formData.year = this.selectYear(val)
    },
    date(val) { 
      this.dateFormatted = this.formatDate(val);
    },
    sendForm(formData) {
      if (formData) 
      this.formData.dt_feriado = null
      this.formData.descricao = null
      this.dateFormatted = null
      this.date = null
    },
  },
  methods: {
    sendFilter(){
      if(this.$refs.FeriadosFilterForm.validate()){
        this.sendForm(this.formData)
      }
    },
    wip() {
      this.formData.dt_feriado = null
      this.formData.descricao = null
      this.dateFormatted = null
      this.date = null
      this.$router.push('/faturamento/agendacronogramas')
    },
    selectYear (date) {
      if (!date) return null
      return Number(date.substring(6,11))
    },
    formatDate (date) {
        if (!date) return null
        const [year, month, day] = date.split('-')
        return `${day}/${month}/${year}`
      },
    parseDate (date) {
        if (!date) return null
        const [day, month, year] = date.split('/')
        return `${year}-${month}-${day}`
    },
  },
  props: {
    sendForm: Function,
    showBtn: Boolean,
    sendPrestador: Function,
    prestadores: Array
  }
}
</script>

<style>

</style>